// React Imports
import * as React from 'react';
import {useEffect, useState} from "react";

import {useDispatch, useSelector} from "react-redux";

// Mui Imports
import Box from '@mui/material/Box';
import Drawer from '@mui/material/Drawer';

// App Imports
import {
    DataGrid,
    GridToolbarColumnsButton,
    GridToolbarContainer,
    GridToolbarDensitySelector, GridToolbarExport,
    GridToolbarFilterButton
} from "@mui/x-data-grid";
import CustomFooter from "../../CommonComponents/GridCustomFooter";
import {changeContractDetailList} from "./contractDetailListSlice";
import {getContractCdpList} from "../ContractClient";
import {Stack} from "@mui/material";
import Typography from "@mui/material/Typography";


// Main Function
export default function ContractCdpListDrawer() {


    // ****************** BEGIN STATES ****************************

    const [contractCdpList, setContractCdpList] = useState([]);

    // ****************** END STATES ****************************


    // ****************** BEGIN STORE ****************************

    const selectorContractId = useSelector((state) => state.contractDetailListSlc.value.contractId);
    const selectorContractName = useSelector((state) => state.contractDetailListSlc.value.contractName);
    const selectorDataPointId = useSelector((state) => state.contractDetailListSlc.value.dataPointId);
    const selectorCdpListDrawerState = useSelector((state) => state.contractDetailListSlc.value.cdpListDrawerState);

    // ********************** END STORE ********************************


    // ****************** BEGIN DISPATCH ****************************

    const dispatchData = useDispatch();

    // ****************** END DISPATCH ****************************


    // ****************** BEGIN FETCH ****************************

    const fetchContractCdpList = () =>
        getContractCdpList(selectorContractId, selectorDataPointId)

            .then(data => {
                console.log("this as my response");
                console.log(data);
                setContractCdpList(data);
            });

    // ****************** END FETCH ****************************


    // ******************** BEGIN USE EFFECTS *******************

    useEffect(() => {
        fetchContractCdpList();
    }, [ useSelector((state) => state.contractDetailListSlc.value.cdpListDrawerState)===true]);

// ******************** END USE EFFECTS *******************


    // ***************** BEGIN CONTROLS ***************************

    function closeContractCdpListDrawer() {
        dispatchData(changeContractDetailList({id: 0, cdpListDrawerState: false}));
    };

    // *************** END CONTROLS *******************************


    // ***************** BEGIN MISC ***************************

    const renderContractCdpList = contractCdpList => {
        if (contractCdpList.length <= 0) {
            return "No Data";
        }}


    // *************** END MISC *******************************


    // ****************** BEGIN TOOLBAR ****************************

    function CustomToolbar() {
        return (

            <GridToolbarContainer>
                <Box sx= {{
                    flexGrow: 1}}>
                    <GridToolbarColumnsButton />
                    <GridToolbarFilterButton sx={{mr: 3}} />
                    <GridToolbarDensitySelector />

                </Box>
                <Box sx= {{
                    flexGrow: 1}}>
                </Box>
                <Box sx= {{
                    flexGrow: 1,
                    display: { xs: 'none', md: 'flex' },
                    alignContent: 'flex-end',
                    justifyContent: 'flex-end',
                    ml:30
                }}>
                    <GridToolbarExport  />
                </Box>
            </GridToolbarContainer>
        );
    }

// ********************END TOOLBAR ********************************


    // ****************** BEGIN COLUMNS ****************************

    const columns = contractCdpList => [

        {
            field: 'id',
            headerName: 'ID',
            description: '',
            sortable: true,
            editable: false,
            width: 50,
            hide: true,
        },
        {    field: 'sectionOrdinal',
            headerName: 'Section #',
            description: '',
            sortable: true,
            width: 80,
            hide: false,
        },
        {
            field: 'sectionName',
            headerName: 'Name',
            description: '',
            sortable: true,
            editable: false,
            width: 500,
        },
        {    field: 'cdpOrdinal',
            headerName: 'Order',
            description: '',
            sortable: true,
            width: 80,
            hide: false,
        },
        {
            field: 'dataPointId',
            headerName: 'DP ID',
            description: '',
            sortable: true,
            editable: false,
            width: 80,
            hide: false,
        },
        {
            field: 'dataPointName',
            headerName: 'Data Point',
            description: '',
            sortable: true,
            editable: false,
            width: 350,
            hide: false,
        },
        {
            field: 'contractLevel',
            headerName: 'Level',
            description: '',
            sortable: true,
            editable: false,
            width: 120,
            hide: false,
        },
        {
            field: 'destinationFolder',
            headerName: 'Destination Folder',
            description: '',
            sortable: true,
            editable: false,
            width: 200,
            hide: false,
        },
    ];

    // ****************** END COLUMNS ****************************


    // ****************** BEGIN RETURN ****************************

    return (
        <div>
            <Drawer
                PaperProps={{
                    sx: { width: 1500 },
                }}
                anchor='right'
                open={selectorCdpListDrawerState}
                initialState={{open: false}}
                onClose={closeContractCdpListDrawer}
            >
                <Box style={{cursor:'pointer'}} sx= {{pl: 2}}>
                    <h1 onClick={() => closeContractCdpListDrawer()}>Contract Data Point List</h1>
                    <Stack direction="row" spacing={1}>
                        {/*<Typography component="span">id:</Typography>*/}
                        {/*<Typography component="span" fontWeight="bold">{selectorContractId}</Typography>*/}
                        {/*<Box sx={{ ml: 6 }} /> /!* Adds extra spacing before 'name:' *!/*/}
                        {/*<Typography component="span">name:</Typography>*/}
                        <Typography component="span" fontWeight="bold">{selectorContractName}</Typography>
                    </Stack>
                </Box>
                <DataGrid
                    experimentalFeatures={{ newEditingApi: true }}
                    initialState={{
                    }}
                    aria-label={"ContractCdpList"}
                    rows={contractCdpList}
                    disableDensitySelector={true}
                    disableColumnSelector={true}
                    columns={columns(contractCdpList)}
                    density={"compact"}
                    pageSize={100}
                    rowsPerPageOptions={[100]}
                    rowKey={contractCdpList => contractCdpList.id}
                    components={{
                        Toolbar: CustomToolbar,
                        Footer: CustomFooter,
                    }}
                />

            </Drawer>
        </div>
    );

    // ****************** END RETURN ****************************

}
